import uploadAdapter from "../components/CKeditor/ckEditorImage";

export function uploadPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return uploadAdapter(loader);
  };
}